import React from 'react';
import './footer.css';
import logo from "./../images/ensenartecorto.png";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";

function Footer() {
  const scrollToSection = (id) => {
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  };

  return (
    <footer id="footer-section" className="site-footer">
      <div className="footer-container">

        {/* Logo + descripción */}
        <div className="footer-col brand">
          <img src={logo} alt="EnsenArte logo" className="footer-logo" />
          <p>Aprende desde casa con programas convalidados y certificados.</p>

          {/* Redes sociales */}
          <div className="socials">
            <a href="https://www.facebook.com/EnsenarteOnline" className="facebook" target="_blank" rel="noreferrer"><FaFacebookF /></a>
            <a href="https://www.instagram.com/ensenarte.online" className="instagram" target="_blank" rel="noreferrer"><FaInstagram /></a>
            <a href="https://www.tiktok.com/@ensenarte.online" className="tiktok" target="_blank" rel="noreferrer"><FaTiktok /></a>
            <a href="https://wa.me/573021233853" className="whatsapp" target="_blank" rel="noreferrer"><FaWhatsapp /></a>
          </div>
        </div>

        {/* Enlaces */}
        <div className="footer-col">
          <h4>Enlaces</h4>
          <ul>
            <li><a href="#cursos" onClick={(e) => { e.preventDefault(); scrollToSection('cursos'); }}>Cursos</a></li>
            <li><a href="#preguntas" onClick={(e) => { e.preventDefault(); scrollToSection('preguntas'); }}>Preguntas frecuentes</a></li>
            <li><a href="#testimonios" onClick={(e) => { e.preventDefault(); scrollToSection('testimonios'); }}>Testimonios</a></li>
            <li><a href="#noticias" onClick={(e) => { e.preventDefault(); scrollToSection('noticias'); }}>Noticias</a></li>
          </ul>
        </div>

        {/* Contacto */}
        <div className="footer-col">
          <h4>Contacto</h4>
          <p>Email: institutoeducativoensenarte@gmail.com</p>
          <p>Tel: <a href="https://wa.me/573021233853" target="_blank" className="phone-button">+57 302 123 3853</a></p>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} EnsenArte. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}

export default Footer;